<template>
  <div>
    <div class="flex items-center justify-between pb-6">
      <p class="text-2xl font-medium">
        Featured Categories
      </p>
      <div class="hidden md:flex">
        <div
          class="rounded-full bg-smoke-100 w-10 h-10 opacity-50 cursor-pointer flex items-center mr-3"
          @click="slideProduct(-1)"
        >
          <img src="@/assets/icons/chevronLeft.svg" class="mx-auto">
        </div>
        <div
          class="rounded-full bg-smoke-100 w-10 h-10 opacity-50 cursor-pointer flex items-center"
          @click="slideProduct(1)"
        >
          <img src="@/assets/icons/chevronRight.svg" class="mx-auto">
        </div>
      </div>
    </div>
    <template v-if="categories">
      <ItemsCarousel
        :items="6"
        :margin="10"
        :dots="false"
        ref="carousel"
      >
        <div
          v-for="(category, index) in firstRowCategories"
          :key="`category-section-box-1-${index}`"
        > 
          <router-link :to="`/${category.name}`">
            <div class="bg-smoke-100 p-4 hover:text-blue hover:bg-white text-center ellipsis-on-overflow">
              <img class="mx-auto" :src="categoryImage(category.name)">
              <span class="whitespace-nowrap">{{ category.name }}</span>
            </div>
          </router-link>
          <div v-if="getCategoryName(index)" class="pt-2.5">
            <router-link :to="`/${getCategoryName(index)}`">
              <div class="bg-smoke-100 p-4 hover:text-blue hover:bg-white text-center ellipsis-on-overflow">
                <img class="mx-auto" :src="categoryImage(getCategoryName(index))">
                <span class="whitespace-nowrap">{{ getCategoryName(index) }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </ItemsCarousel>
    </template>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import categoriesJson from '@/assets/json/categories'
import ItemsCarousel from '@/shared/components/shared/ItemsCarousel'

export default {
  name: 'CategoriesSection',
  components: { ItemsCarousel },
  data() {
    return {
      categories: null
    }
  },
  computed: {
    categoriesData() {
      return categoriesJson
    },
    firstRowCategories() {
      return this.categories.length > (this.isMobile ? 3 : 11)
        ? this.categories.slice(
            0, Math.ceil(this.categories.length / 2)
          )
        : this.categories.slice(0, 6)
    },
    secondRowCategories() {
      return this.categories.length > (this.isMobile ? 3 : 11)
        ? this.categories.slice(Math.ceil(this.categories.length / 2))
        : this.categories.slice(6)
    },
    isMobile() {
      return window.innerWidth < 600
    }
  },
  async created() {
    this.categories = await this.fetchFeaturedCategories()
  },
  methods: {
    ...mapActions ([
      'fetchFeaturedCategories'
    ]),
    categoryImage(category) {
      if (this.categoriesData[category]) {
        return require(`@/assets/images/categories/${this.categoriesData[category]}`)
      } else {
        return require('@/assets/images/categories/placeholder.png')
      }
    },
    getCategoryName(index) {
      return this.secondRowCategories[index]
        ? this.secondRowCategories[index].name
        : null
    },
    slideProduct(val) {
      const navs = this.$refs.carousel.$el.querySelectorAll('.owl-nav')
      navs.forEach(nav => {
        val === 1 ? nav.lastChild.click() : nav.firstChild.click()
      })
    }
  }
}
</script>
